import React from "react";

import { conversationFilters } from "../../../constants";
import { onKeyDownHandler } from "../../../../../shared";

const FilterByResponseStatusComponent = ({
  selectedFilter,
  setSelectedFilter,
}) => {
  return (
    <div className="p-2 border-2 border-bottom">
      <div className="d-flex align-items-center bg-secondary bg-opacity-10 rounded-4 p-1 overflow-x-auto custome-sidebar">
        {conversationFilters.map((ftr) => (
          <div
            className={`px-3 py-1 rounded-4 w-100 text-center fw-bold ${
              selectedFilter.value === ftr.value &&
              "bg-white shadow filter-item"
            }`}
            role="button"
            key={ftr.value}
            tabIndex={0}
            onClick={() => setSelectedFilter(ftr)}
            onKeyDown={(e) => {
              onKeyDownHandler(e, () => {
                setSelectedFilter(ftr);
              });
            }}
          >
            {ftr.name}
          </div>
        ))}
      </div>
    </div>
  );
};

export default React.memo(FilterByResponseStatusComponent);
